import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app'
import { environment } from './environments/environment'
import { enableProdMode } from '@angular/core'

// Some dependencies (e.g., sockjs-client) expect a Node-like `global`. Expose
// `window` as `global` on the browser. Moved here from src/polyfills.ts so the
// polyfills config contains only package specifiers, which lets the Angular
// CLI correctly detect this as a zoneless app (see isZonelessApp heuristic).
;(window as unknown as { global: unknown }).global = window

if (environment.production) {
	enableProdMode()
	if (window) {
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		window.console.log = () => {}
		// console.error عمداً ساکت نمی‌شود: خطاهای hydration/bootstrap باید در پروداکشن
		// دیده شوند وگرنه باگ‌هایی مثل چیدمان SSR بدون آنکه کسی بفهمد باقی می‌مانند.
	}
}

// هیدریشن (provideClientHydration + withEventReplay) در appConfig ثبت شده است تا
// سرور هم آن را ببیند و اطلاعات hydration را serialize کند؛ ثبت آن فقط اینجا
// باعث NG0505 و رندر کامل سمت کلاینت می‌شد (از دست رفتن کلیک‌های اولیه).
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
